import React from 'react'
import TimeCountDown from '../countdown';


const Hero5 = (props) => {
    return (
        <section id="home" className="wpo-hero-style-4">
            <div className="wedding-announcement">
                <div className="couple-text">
                <h2>María & Cristian</h2>
                    <p >Nos casamos el 21 de junio de 2025</p>
                    <br></br>
                    <p style={{
                        fontStyle: 'italic',
                        fontWeight: '300',
                        fontSize: 'xx-large'
                    }}>¡Estás invitado a nuestro día especial!</p>
                    <div className="wpo-wedding-date">
                        <div className="clock-grids">
                            <TimeCountDown/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero5;